import { Injectable } from '@angular/core';
import { Urls } from '../utilities/urls.component';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';
//import { CurbiOrgListDTO, CurbiOrgListResponseDTO } from '../models/CurbiOrgListResponseDTO';
import { OrganisationListDTO } from '../models/OrganisationListDTO';

@Injectable()
export class CommonDataService {

  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {    
  }

  getCurbiOrgList() {
    var url: string = Urls.API_ENDPOINT + Urls.ORGANISATIONLIST.getOrganizationNameList;
    return this.http.get<OrganisationListDTO>(url, this.headers.getCommonHttpHeaders());
  }

}
